var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.439,
    height: 7.447,
    viewBox: "0 0 13.439 7.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_7787532_next_arrow_direction_down_left_icon",
    "data-name": "7787532_next_arrow_direction_down_left_icon",
    d: "M6.673,4.954,1.571.25A.91.91,0,0,0,.939,0,.91.91,0,0,0,.307.25.777.777,0,0,0,.036.833a.776.776,0,0,0,.271.583l5.1,4.7a.763.763,0,0,1,0,1.166L.262,12.032a.78.78,0,0,0,0,1.166.948.948,0,0,0,1.264,0l5.1-4.7A2.366,2.366,0,0,0,6.673,4.954Z",
    transform: "translate(13.439) rotate(90)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronWhite);
export default __webpack_public_path__ + "static/media/chevron_white.b20cb1211e9eac623fefa178559dbb20.svg";
export { ForwardRef as ReactComponent };